import React from 'react';

import {BaseSeedDataConfig, SeedDataConfigType} from 'analysis-tool/create-analysis-modal/SeedDataTypes';

interface MultipleStudiesData {
  studyIds: Array<string>;
}

export type MultipleStudiesSeedDataConfig = BaseSeedDataConfig<
  SeedDataConfigType.MULTIPLE_STUDIES,
  MultipleStudiesData
>;

export function validateMultipleStudiesSeedDataConfigValid(_config: MultipleStudiesSeedDataConfig): boolean {
  // None of the fields in MultipleStudiesSeedDataConfig are editable in the seed data editor,
  // so the config is always valid at this stage.
  return true;
}

export function MultipleStudiesSeedDataConfigEditor(_props: {
  value: MultipleStudiesSeedDataConfig;
  onChange: (value: MultipleStudiesSeedDataConfig) => void;
}): JSX.Element {
  // TODO(BNCH-151204): Render a summary of the selected studies once the cross-study editor UI is built.
  return <></>;
}
